import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FaTimes, FaInstagram } from 'react-icons/fa';

const Popup = () => {
    const [isVisible, setIsVisible] = useState(false);
    const popupData = useSelector(state => state.data.popupData);

    useEffect(() => {
        if (popupData?.isActive) {
            const timer = setTimeout(() => setIsVisible(true), 1000);
            return () => clearTimeout(timer);
        }
    }, [popupData]);

    const handleClose = () => setIsVisible(false);

    if (!isVisible || !popupData) return null;

    const getYouTubeEmbedUrl = (url, autoplay = true) => {
        let videoId = null;
        if (url.includes('watch?v=')) {
            videoId = url.split('v=')[1]?.split('&')[0];
        } else if (url.includes('youtu.be/')) {
            videoId = url.split('youtu.be/')[1]?.split('?')[0];
        } else if (url.includes('embed/')) {
            videoId = url.split('embed/')[1]?.split('?')[0];
        }
        const baseUrl = videoId ? `https://www.youtube.com/embed/${videoId}` : url;
        const params = new URLSearchParams();
        if (autoplay) {
            params.append('autoplay', '1');
            params.append('mute', '1');
        }
        params.append('rel', '0');
        params.append('controls', '1');
        params.append('modestbranding', '1');
        return `${baseUrl}?${params.toString()}`;
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={handleClose}>
            <div className="bg-white rounded-lg shadow-2xl max-w-3xl w-full mx-4 relative max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
                <button
                    onClick={handleClose}
                    className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 bg-white rounded-full p-1 shadow-lg z-10"
                >
                    <FaTimes size={20} />
                </button>

                <div className="p-4">
                    {/* YouTube dengan autoplay */}
                    {popupData.type === 'youtube' && (
                        <div className="relative w-full mb-4" style={{ paddingBottom: '56.25%' }}>
                            <iframe
                                className="absolute top-0 left-0 w-full h-full rounded-lg"
                                src={getYouTubeEmbedUrl(popupData.content, true)}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </div>
                    )}

                    {/* Tipe lainnya (video lokal, gambar) */}
                    {popupData.type === 'video' && (
                        <video controls className="w-full rounded-lg mb-4">
                            <source src={popupData.content} type="video/mp4" />
                        </video>
                    )}
                    {popupData.type === 'image' && (
                        <img src={popupData.content} alt={popupData.title} className="w-full rounded-lg mb-4" />
                    )}

                    {/* Judul, Subjudul, Tombol, dll */}
                    <h2 className="text-2xl font-bold text-[#0F4C3A] mb-1">{popupData.title}</h2>
                    {popupData.subtitle && (
                        <p className="text-gray-700 text-lg mb-3">{popupData.subtitle}</p>
                    )}

                    {/*{popupData.buttons && popupData.buttons.length > 0 && (
                        <div className="flex flex-wrap gap-3 mb-4">
                            {popupData.buttons.map((btn, idx) => (
                                <a
                                    key={idx}
                                    href={btn.link}
                                    className="px-4 py-2 bg-[#0F4C3A] text-white rounded hover:bg-[#0a3a2c] transition"
                                >
                                    {btn.label}
                                </a>
                            ))}
                        </div>
                    )}*/}

                    {popupData.extra && (
                        <div className="border-t pt-3 mt-3 text-gray-600">
                            {popupData.extra.instagram && (
                                <div className="flex items-center gap-2 mb-2">
                                    <FaInstagram className="text-pink-600" />
                                    <a
                                        href={popupData.extra.instagramLink || '#'}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 hover:underline"
                                    >
                                        {popupData.extra.instagram}
                                    </a>
                                    <span className="text-sm text-gray-500">Ikuti kami di Instagram</span>
                                </div>
                            )}
                            {popupData.extra.sambutan && (
                                <div className="text-sm bg-gray-50 p-3 rounded">
                                    <p className="font-semibold">Sambutan Kepala BPKAD</p>
                                    <p className="mt-1">{popupData.extra.sambutan}</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Popup;